import SearchIcon from '../../assets/images/search.svg';

export default function Searchbar({
  customClass = '',
  placeholder = '',
  searchKeyword,
  onChange,
}) {
  return (
    <div
      className={`w-full px-4.5 space-x-3 flex items-center justify-center bg-[#F9FAFB] rounded-[10px] border-1 border-[#D5D7DA] ${customClass}`}
    >
      <img src={SearchIcon} alt="Search Icon" className="w-6 h-6" />
      <input
        className="w-full text-sm text-[#717680] leading-[20px]"
        value={searchKeyword}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
}
